"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { MainShopProduct } from "@/core/models/shop-product-model";
import { Heading } from "@/components/ui/Heading";
import { ArrowLeftIcon } from "lucide-react";
import Link from "next/link";
import { useDictionary } from "@/core/hooks/use-dictionary";
import ProductCard from "./ProductCard";

export default function ProductBar({ data }: { data: MainShopProduct }) {
  const { dictionary } = useDictionary();

  return (
    <div className="w-full col-span-12">
      <div className="flex justify-between items-center mb-10 max-md:flex-col max-md:items-start gap-4">
        <div>
          <Heading level={3}>{data.title}</Heading>
          <p className="text-primary-600">{data.description}</p>
        </div>
        {data.link && (
          <Link className="text-primary-600 flex items-center gap-1" href={data.link}>
            {dictionary.ui?.pages.seeAll}
            <ArrowLeftIcon className="stroke-1 size-4 ltr:rotate-180" />
          </Link>
        )}
      </div>
      <Swiper
        modules={[Pagination]}
        spaceBetween={16}
        slidesPerView="auto"
        pagination={{ clickable: true }}
        className="w-full"
        style={{ paddingBottom: "50px" }}
      >
        {data.items.map((item) => (
          <SwiperSlide key={item.id} style={{ width: "300px" }}>
            <ProductCard product={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}